import { render, staticRenderFns } from "./BriefPanel.vue?vue&type=template&id=2f1133f3&scoped=true"
import script from "./BriefPanel.vue?vue&type=script&lang=js"
export * from "./BriefPanel.vue?vue&type=script&lang=js"
import style0 from "./BriefPanel.vue?vue&type=style&index=0&id=2f1133f3&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1133f3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f1133f3')) {
      api.createRecord('2f1133f3', component.options)
    } else {
      api.reload('2f1133f3', component.options)
    }
    module.hot.accept("./BriefPanel.vue?vue&type=template&id=2f1133f3&scoped=true", function () {
      api.rerender('2f1133f3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/EditorControl/BriefPanel.vue"
export default component.exports